<div>Dynamic component</div>